<p-popover #projectPopover>
  <div class="tw:flex tw:flex-col tw:min-w-[18rem] tw:max-w-[22rem]">
    @if (project.isLoading()) {
      <cor-skeleton [type]="SKELETON_TYPES.LIST" />
    } @else {
      <p-listbox
        test-id="project-list-hide"
        style="
          --p-listbox-border-color: transparent;
          --p-listbox-list-header-padding: 0.5rem 0.5rem 0.2rem;
          --p-listbox-option-padding: 0;
          --p-listbox-list-gap: 0.25rem;
          --p-listbox-shadow: transparent;
          width: 100%;
        "
        [options]="project.options()"
        [ngModel]="selectedProject()?.slug || 'All Projects'"
        (onChange)="$event.value && project.onSelect($event.value); hide()"
        [filter]="true"
        filterBy="name,description"
        filterPlaceHolder="Search projects"
        optionLabel="name"
        optionValue="slug"
        dataKey="slug"
        [highlightOnSelect]="false"
        scrollHeight="18rem">
        <ng-template
          let-item
          pTemplate="item">
          <div
            class="tw:flex tw:px-2 tw:py-1 tw:w-full tw:items-center tw:gap-2 tw:min-w-0 tw:group"
            [attr.test-id]="'project-list-option-' + item.slug"
            [ngClass]="{
              'tw:bg-highlight': selectedProject()?.slug === item.slug,
            }">
            <i class="pi pi-box tw:shrink-0 tw:text-primary"></i>
            <span class="tw:flex-1 tw:min-w-0 tw:truncate tw:font-medium">{{ item.name }}</span>

            <div
              test-id="project-list-stop-propagation"
              (click)="$event.stopPropagation()"
              class="tw:invisible tw:group-hover:visible">
              <p-button
                test-id="project-list-project-actions-menu-toggle"
                [buttonProps]="{ autofocus: false }"
                type="button"
                severity="secondary"
                variant="text"
                size="small"
                icon="pi pi-ellipsis-v"
                (click)="
                  $event.stopPropagation();
                  project.activePopover.set(projectPopover);
                  projectActionsMenu.toggle($event)
                " />
              <p-menu
                #projectActionsMenu
                appendTo="body"
                [popup]="true"
                [model]="item.menuItems" />
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="empty">
          <div class="tw:px-3 tw:py-4 tw:text-sm tw:text-muted-color">No projects available</div>
        </ng-template>

        <ng-template pTemplate="emptyfilter">
          <div class="tw:px-3 tw:py-4 tw:text-sm tw:text-muted-color">
            No projects match your search
          </div>
        </ng-template>

        <ng-template pTemplate="footer">
          <div class="tw:border-t tw:border-surface tw:p-1">
            <div
              test-id="project-list-hide-2"
              class="tw:flex tw:w-full tw:items-center tw:gap-2 tw:rounded tw:px-2 tw:py-2 tw:text-left tw:hover:bg-emphasis tw:cursor-pointer"
              [ngClass]="{
                'tw:bg-highlight-emphasis': !selectedProject(),
              }"
              (click)="project.onSelect(null); hide()">
              <div class="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col">
                <span class="tw:truncate tw:font-medium">All Projects</span>
                <span class="tw:truncate tw:text-xs tw:text-muted-color">
                  View object across all projects
                </span>
              </div>
            </div>
          </div>
          <div class="tw:border-t tw:border-surface tw:p-1">
            <p-button
              test-id="project-list-add-new-project"
              [buttonProps]="{ autofocus: false }"
              variant="text"
              size="small"
              fluid
              icon="pi pi-plus"
              label="Add new project"
              (click)="hide(); project.dialog.onShow()" />
          </div>
        </ng-template>
      </p-listbox>
    }
  </div>
</p-popover>

<p-dialog
  [visible]="project.dialog.isVisible()"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="tw:w-4/5 tw:md:w-1/2 tw:lg:w-1/3 tw:overflow-y-auto"
  [header]="project.dialog.form.controls.id.value ? 'Edit project' : 'Add project'">
  <ng-template pTemplate="header">
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:w-full">
      <div class="tw:text-xl tw:font-semibold">
        {{ project.dialog.form.controls.id.value ? 'Edit project' : 'Add project' }}
      </div>
      <p-button
        test-id="project-list-on-close"
        [buttonProps]="{ autofocus: false }"
        icon="pi pi-times"
        severity="secondary"
        variant="text"
        rounded
        [disabled]="project.dialog.isSaving()"
        (click)="project.dialog.onClose()" />
    </div>
  </ng-template>
  <div class="tw:flex tw:flex-col">
    <cor-input-container label="Name">
      <input
        test-id="project-list-name"
        pInputText
        [formControl]="project.dialog.form.controls.name"
        placeholder="Enter a project name" />
      <cor-field-error
        [visible]="
          project.dialog.form.controls.name.invalid &&
          project.dialog.form.controls.name.touched &&
          project.dialog.form.controls.name.errors?.pattern
        "
        errorMsg='Project name cannot contain reserved characters: "(", ")"' />
    </cor-input-container>

    <cor-input-container label="Description">
      <textarea
        test-id="project-description"
        pTextarea
        [formControl]="project.dialog.form.controls.description"
        rows="4"
        placeholder="Enter project description"></textarea>
    </cor-input-container>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      test-id="project-list-cancel"
      [buttonProps]="{ autofocus: false }"
      severity="secondary"
      label="Cancel"
      [disabled]="project.dialog.isSaving()"
      (click)="project.dialog.onClose()" />
    <p-button
      test-id="project-list-create"
      [buttonProps]="{ autofocus: false }"
      type="submit"
      [label]="project.dialog.form.controls.id.value ? 'Save' : 'Create'"
      [loading]="project.dialog.isSaving()"
      [disabled]="project.dialog.isSaving()"
      (click)="project.dialog.onSave()" />
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="project.deleteDialog.isVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [header]="`Delete '${project.deleteDialog.item()?.name}' ?`"
  (onHide)="project.deleteDialog.onHide()"
  [closeOnEscape]="true">
  @if (project.deleteDialog.item(); as item) {
    <div class="tw:flex tw:flex-col tw:gap-2">
      <p-message
        severity="error"
        variant="simple"
        [motionOptions]="{ disabled: true }">
        {{ `Are you sure you want to delete the selected project - '${item.name}'?` }}
        <br />
        <strong>This is an irreversible change</strong>
      </p-message>
      <label>
        {{ `Type \'${item.name}\' to confirm deletion:` }}
        <input
          test-id="project-delete-confirmation-input"
          type="text"
          pInputText
          fluid
          [(ngModel)]="project.deleteDialog.confirmationInput"
          [disabled]="project.deleteDialog.isDeleting()"
          [placeholder]="item.name"
          autocomplete="off"
          (keydown.enter)="project.deleteDialog.onDelete()" />
      </label>
    </div>
  }
  <ng-template pTemplate="footer">
    <div class="tw:flex tw:gap-2 tw:justify-end">
      <p-button
        test-id="project-list-cancel-2"
        [buttonProps]="{ autofocus: false }"
        (click)="project.deleteDialog.onHide()"
        [disabled]="project.deleteDialog.isDeleting()"
        severity="secondary"
        [outlined]="true"
        label="Cancel" />
      <p-button
        test-id="project-list-delete"
        [buttonProps]="{ autofocus: false }"
        (click)="project.deleteDialog.onDelete()"
        [loading]="project.deleteDialog.isDeleting()"
        [pTooltip]="
          !project.deleteDialog.isDeleteConfirmed()
            ? 'Please type the name above to confirm deletion'
            : null
        "
        [disabled]="!project.deleteDialog.isDeleteConfirmed() || project.deleteDialog.isDeleting()"
        severity="danger"
        label="Delete" />
    </div>
  </ng-template>
</p-dialog>
